export const getFormattedDateMMMDD = (iso: string) => {
  const date = new Date(iso);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const monthName = months[date.getMonth()];
  const day = date.getDate().toString().padStart(2, "0");

  return `${monthName} ${day}`;
};
